import { AlertModal, AlertModalActions } from './types'
import { action } from 'typesafe-actions'

export const setAlertModalAction = (data: AlertModal) =>
  action(AlertModalActions.SET_ALERT_MODAL, data)

export const clearModalAction = () => action(AlertModalActions.CLEAR_MODAL)
